module.exports = __webpack_public_path__ + "img/0020.a73ec3b6.jpg";